import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import MuskiGame from "@/game/MuskiGame";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<MuskiGame />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
